export default __webpack_public_path__ + "static/media/rasm1.ac9bbc2d.png";